import Controller from "./manualInvoiceItem.controller";
import template from "./manualInvoiceItem.html";

const manualInvoiceItem = {
  template,
  controller: Controller,
};

export default manualInvoiceItem;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItem/manualInvoiceItem.component.js